var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backButton",staticStyle:{"z-index":"20"}},[(_vm.fab)?_c('v-btn',{attrs:{"fab":""},on:{"click":function($event){_vm.hasHistory() 
          ? _vm.$router.go(-1) 
          : _vm.$router.push('/')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1):_c('v-btn',{attrs:{"rounded":""},on:{"click":function($event){_vm.hasHistory() 
          ? _vm.$router.go(-1) 
          : _vm.$router.push('/')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" Home ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }